export default __webpack_public_path__ + "static/logo_white_LST_wo_tag-267a4d2a482c01276d874209f7cd4935.png";